import { useState, useRef, useCallback } from "react";
import "./GradientSlider.css";

// const LEFT_COLOR = "#6ee07a";   
// const RIGHT_COLOR = "#d966a8";  
const NEUTRAL_COLOR = "#c8c8d0";

export default function GradientSlider({gauge_color1,gauge_color2,value}) {

  const containerRef = useRef(null);
  const dragging = useRef(false);

  const percentage = 100 - value;

  const [position, setPosition] = useState(percentage/100);

  const getPercent = (p) => Math.round((p - 0) * 100);

  const clamp = (val) => Math.max(0, Math.min(1, val));

  const getPosFromEvent = useCallback((e) => {
    const rect = containerRef.current.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    return clamp((clientX - rect.left) / rect.width);
  }, []);

  const handleMouseDown = (e) => {
    dragging.current = true;
    e.preventDefault();
  };

  const handleMouseMove = useCallback((e) => {
    if (!dragging.current) return;
    setPosition(getPosFromEvent(e));
  }, [getPosFromEvent]);

  const handleMouseUp = () => { dragging.current = false; };

  const handleTrackClick = (e) => {
    if (e.target === containerRef.current || e.target.classList.contains("track")) {
      setPosition(getPosFromEvent(e));
    }
  };

  const handleKeyDown = (e) => {
    const step = 0.01;
    if (e.key === "ArrowRight") setPosition((p) => clamp(p + step));
    if (e.key === "ArrowLeft") setPosition((p) => clamp(p - step));
    if (e.key === "Home") setPosition(0);
    if (e.key === "End") setPosition(1);
  };

  const gradientStyle = {
    background: `linear-gradient(to right, ${gauge_color1}, ${NEUTRAL_COLOR} ${position * 100}%, ${gauge_color2})`,
  };

  const val = getPercent(position);

  return (
    <>
      {/* <style>{styles}</style> */}
      <div
        className="slider-wrapper"
        // onMouseMove={handleMouseMove}
        // onMouseUp={handleMouseUp}
        // onMouseLeave={handleMouseUp}
        // onTouchMove={(e) => { if (dragging.current) setPosition(getPosFromEvent(e)); }}
        // onTouchEnd={() => { dragging.current = false; }}
      >
        <div
          className="track-container"
          ref={containerRef}
          onClick={handleTrackClick}
        >
          <div className="track" style={gradientStyle} />
          <div
            className="thumb"
            style={{ left: `${position * 100}%` }}
            // onMouseDown={handleMouseDown}
            // onTouchStart={(e) => { dragging.current = true; }}
            // onKeyDown={handleKeyDown}
            role="slider"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={percentage}
            tabIndex={0}
          >
            <div className="percent-label">{percentage}%</div>
          </div>
        </div>

        {/* <div className="labels">
          <span>Fully</span>
          <span>Somewhat</span>
          <span>Fully</span>
        </div> */}
        
      </div>
    </>
  );
}
